import { Scrollbar, type ScrollbarProps } from "@etecture/rex";
import "@etecture/rex/styles.css";
import type React from "react";
import type { ReactNode } from "react";

export interface ScrollerProps extends ScrollbarProps {
  children: ReactNode;
}

export const Scroller: React.FC<ScrollerProps> = (props) => {
  const { children, ...scrollbarProps } = props;
  return <Scrollbar {...scrollbarProps}>{children}</Scrollbar>;
};
